module.exports = __webpack_public_path__ + "static/media/gl.bca76460.svg";